import Reflux from 'reflux';

const RefreshActions = Reflux.createActions([
  'changeInterval',
  'disable',
  'enable',
]);

export default RefreshActions;
